import * as React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Modal as ModalStrap } from 'reactstrap';
import { useAuth } from "../../../Services/AuthContext";
import FormContainer from "../../Models/FormContainer";
import ResetPassword from "../../Editors/ResetPassword";
import { fetchJSON } from 'refresh-fetch';
import useFunction from "../../../utils/Hooks/useFunction";

import { Button} from "reactstrap";
import { login } from '../../../Services/Auth';
import { useAlert } from "../../../Services/AlertContext";

const ConfirmEmail = ({ detail }) => {
    const [authUser] = useAuth();
    const { getUrl, confirmEmail, validation, editor } = detail;
    const { id } = useParams();
    const alert = useAlert();
    const [item, setItem] = useState();
    let history = useHistory();
    const [user, setUser] = useAuth();
    const [loading, setLoading] = useState();
    const [saving, setSaving] = useState();
    
    const [handleSubmit, setHandleSubmit] = useFunction();

    const onClose = () => {
        authUser.jwt ? history.goBack() : history.push('/login')
    }
    useEffect(() => {
        try {
            if (!item && !loading) {
                setLoading(true);
                fetchJSON(getUrl + id).then((result) => {
                    if (result.response.status === 200) {
                        const p = { password: '', checkPassword: '' };
                        if (result.body.id !== '00000000-0000-0000-0000-000000000000') {
                            setItem({ ...result.body, ...p });
                            setLoading();
                            if (user.email !== result.body.email) {
                                setUser({
                                    type: 'removeAuthDetails'
                                });
                            }
                            else {
                                history.go("/Home");
                            }
                        }

                    }
                    else {
                        alert({
                            title: "Could not find anything matching your request.", body: <div>Hmmm...</div>
                        });
                    }
                }, (error) => { console.log("Error", error) });
            }
        }
        catch (e) {
            console.log("Exception",e);
        }

    }, [alert,getUrl,history,id,item,loading,setUser,user.email]);
    const onSubmit = (values) => {
        try {
            setSaving(true);
            const val = { ...values, token: history.location.pathname.substr(history.location.pathname.indexOf(id)+id.length+1) }
            return fetchJSON(confirmEmail, { method: 'POST', body: JSON.stringify(val) }).then((result) => {
                setSaving(false);
                if (result.response.status === 200) {
                    var r = result.body;
                    
                    var messages = r.messages.map((x) => <p>{x}</p>);
                  
                    if (r.success) {
                       
                        login(values.email, values.password, setUser).then(() => history.push("/home"));
                      
                        return true;
                    }
                    else {
                        alert({ title: "Error Registering", body: <div>{messages}</div> })
                        return false;
                    }

                }
                else {
                  
                    alert({ title: "Error", body: <div>{r.messages.map((x) => <p>{x}</p>)}</div> })
                }
            }, (error) => {
                setSaving(false);
                alert({ title: "Error", body: JSON.stringify(error) })
            });
        }
        catch (e) {
            setSaving(false);
            alert({ title: "Error", body: JSON.stringify(e) })
        }
    };


    const s = authUser.jwt ? null : { width: '100vw', height: '100vh', backgroundImage: "url(/img/Light-Jet.jpg)" };
    return <div style={s}>
        {item ? <ModalStrap isOpen={true} size="lg" contentClassName="transparentmodal" centered>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
                <img alt='jetbidders' src={'/img/logo.png'} style={{ width: '60%', height: 'auto', marginTop: '5vh' }} />
            </div>
            <h1>Welcome!</h1>
            <FormContainer initialValues={{ ...item }} validationSchema={validation} setHandleSubmit={setHandleSubmit} onSubmit={onSubmit} edit style={{ marginBottom: '100px' }}>
                {editor}
                <ResetPassword hide />


                <div style={{ margin: 15, marginBottom: '50px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <Button style={{ width: '40%' }} color='secondary' type='button' onClick={onClose} disabled={loading} >Go Back</Button>
                    <Button onClick={handleSubmit} style={{ width: '40%' }} color='primary' type="submit" disabled={loading||saving}>
                        {loading ? "Loading..." : saving?"Saving...":"Complete Sign up."}
                    </Button>
                    
                </div>
            </FormContainer >
        </ModalStrap> : null}
    </div>
}
export default ConfirmEmail;